export default __webpack_public_path__ + "static/media/SidebarIcon.a24519ee.svg";